import LightDto from "../../api/smartHome/LightDto";

class Light {
    private id: number;
    private on: boolean;
    private bri: string;
    private alert: string;
    private mode: number;
    private reachable: boolean;
    private name: string;
    private room: string;
    private type: string;

    constructor(id: number, on: boolean, bri: string, alert: string, mode: number, reachable: boolean, name: string, room: string, type: string) {
        this.id = id;
        this.on = on;
        this.bri = bri;
        this.alert = alert;
        this.mode = mode;
        this.reachable = reachable;
        this.name = name;
        this.room = room;
        this.type = type;
    }

    getId(): number {
        return this.id;
    }

    getOn(): boolean {
        return this.on;
    }

    getBri(): string {
        return this.bri;
    }

    getAlert(): string {
        return this.alert;
    }

    getMode(): number {
        return this.mode;
    }

    getReachable(): boolean {
        return this.reachable;
    }

    getName(): string {
        return this.name;
    }

    getRoom(): string {
        return this.room;
    }

    getType(): string {
        return this.type;
    }

    static createFrom(dto: LightDto): Light {
        return new Light(dto.id, dto.on, dto.bri, dto.alert, dto.mode, dto.reachable, dto.name, dto.room, dto.type)
    }
}

export default Light;